// extracted by mini-css-extract-plugin
module.exports = {"Inspections":"Inspections_Inspections__2WMdN","Loading":"Inspections_Loading__2vDAK"};